/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Registering_Job_ForInputs */



/**
* | output |
* | --- |
* | "Registering job for {language}" |
*
* @param {Registering_Job_ForInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const registering_job_for = /** @type {((inputs: Registering_Job_ForInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registering_Job_ForInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Enregistrement de la tâche pour ${i?.language}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Auftrag für ${i?.language} wird registriert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Registrazione del lavoro per ${i?.language}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Регистрация вакансии для ${i?.language}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Registrando trabajo para ${i?.language}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在为${i?.language}注册职位`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.language} のジョブを登録しています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.language} के लिए नौकरी पंजीकृत करना`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Cadastrando vaga para ${i?.language}`)
	return /** @type {LocalizedString} */ (`Registering job for ${i?.language}`)
});